import * as React from 'react';

import { bemElement } from 'af-utils/bem.util';

import { SearchInput } from '@acceligentllc/storybook';

import TableTypeEnum from '../tableType.enum';

interface OwnProps {
	filterText: string;
	onFilterTextChange: (filterText: string) => void;
	tableType: TableTypeEnum;
}

type Props = OwnProps;

class FilterInput extends React.PureComponent<Props> {

	render() {
		const { filterText, tableType, onFilterTextChange } = this.props;

		const showSmallButtons = tableType !== TableTypeEnum.DEFAULT;

		return (
			<div className={bemElement('table-container', 'filter', showSmallButtons ? ['stretch'] : [])}>
				<SearchInput
					name="filterText"
					onChange={onFilterTextChange}
					placeholder="Search"
					value={filterText}
				/>
			</div>
		);
	}
}

export default FilterInput;
